// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    position: 'relative',
    padding: 15,
    justifyContent: 'space-between',
    width: '90%',
  },
  mainContainerMobile: {
    position: 'relative',
    display: 'flex',
    padding: 10,
    width: '95%',
    flexDirection: 'column',
  },
  mobileItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  borderBottom: {
    borderBottomColor: GlobalStyles.color.COLOR_GREY,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
  applied: {
    color: GlobalStyles.color.COLOR_GREEN,
    minWidth: 140,
    maxWidth: 140,
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down(500)]: {
      maxWidth: '100%',
      marginLeft: 0,
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 10,
      alignItems: 'center',
    },
  },
  applyText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: 12,
  },
  applyPrice: {
    fontSize: 24,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
      marginRight: 10,
    },
  },
  failed: {
    minWidth: 130,
    maxWidth: 130,
    display: 'flex',
    flexDirection: 'column',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    [theme.breakpoints.down(500)]: {
      flexDirection: 'row',
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
      marginTop: 10,
      alignItems: 'center',
    },
  },
  failedText: {
    display: 'flex',
    flexDirection: 'column',
  },
  failedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  failedBig: {
    width: 35,
    height: 35,
  },
  failedSmall: {
    width: 20,
    height: 20,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 20,
    justifyContent: 'center',
  },
  name: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginBottom: 5,
    [theme.breakpoints.down(500)]: {
      marginBottom: 10,
    },
  },
  infoSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    marginTop: 10,
  },
  failedImageContainer: {
    display: 'flex',
    padding: 5,
  },
  leftPartContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    display: 'flex',
  },
  marginRight: {
    paddingRight: 20,
    width: 30,
  },
  mobileNameDelete: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  mobileFullInfo: {
    display: 'flex',
  },
  mobileInfo: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(500)]: {
      marginLeft: 15,
    },
  },
  bookPhoto: {
    width: 70,
    height: 100,
  },
  deleteButton: {
    backgroundColor: 'transparent',
    padding: 0,
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  searchTextAndStatusContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  imageStatusOk: {
    minWidth: 50,
    width: 50,
    height: 50,
    marginLeft: 10,
  },
  eanColor: {
    color: 'rgb(150, 150, 150)',
  },
  redeemDesktopContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: '6px 4px',
  },
  redeemMobileContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: '4px 0',
  },
  redeemInnerContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffffdd',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 16,
    borderColor: GlobalStyles.color.COLOR_GREEN,
  },
  redeemText: {
    margin: 0,
    padding: 0,
    textTransform: 'uppercase',
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
  },
});

export default styles;
